import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Home, ChevronRight } from 'lucide-react'
import { getPageForPath } from '../seo/pages'
import './Breadcrumb.css'

const Breadcrumb = ({ customItems = [] }) => {
  const location = useLocation()
  const page = getPageForPath(location.pathname)

  const items = customItems.length > 0 ? customItems : page?.breadcrumbs || []
  if (items.length <= 1) return null

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb navigation">
      <ol className="breadcrumb-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return (
            <li key={item.path || `${item.name}-${index}`} className="breadcrumb-item">
              {index === 0 ? (
                <Link to={item.path} className="breadcrumb-link home-link">
                  <Home size={16} />
                  <span>{item.name}</span>
                </Link>
              ) : (
                <>
                  <ChevronRight className="breadcrumb-separator" size={14} />
                  {isLast ? (
                    <span className="breadcrumb-current">{item.name}</span>
                  ) : (
                    <Link to={item.path} className="breadcrumb-link">
                      {item.name}
                    </Link>
                  )}
                </>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumb